import React from "react";

export default function CryptoPanicWidget() {

    return (
        <iframe width="100%" id="rn" title="crypto panic" scrolling="yes" allowTransparency frameBorder="0" src="https://cryptopanic.com/widgets/news/?bg_color=FFFFFF&amp;font_family=sans&amp;header_bg_color=30343B&amp;header_text_color=FFFFFF&amp;link_color=0091C2&amp;news_feed=recent&amp;text_color=333333&amp;title=Latest%20News" height="358" />


    )
}   
